import { render, staticRenderFns } from "./Questionbank.vue?vue&type=template&id=08c37e9b&"
import script from "./Questionbank.vue?vue&type=script&lang=js&"
export * from "./Questionbank.vue?vue&type=script&lang=js&"
import style0 from "./Questionbank.vue?vue&type=style&index=0&lang=scss&scope=true&"
import style1 from "./Questionbank.vue?vue&type=style&index=1&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports